import axios from "axios";
export const getAllContent = (searchState: any) => {
  return axios.get(
    `/content?${searchState.searchTerm ? `searchTerm=${searchState.searchTerm}` : ""}&type=${searchState?.type ? searchState?.type : "terms"}&page=${
      searchState?.page ? searchState.page : 1
    }&limit=${searchState?.size ? searchState?.size : 10}&isPaginated=true${
      searchState?.sectionName ? `&sectionName=${searchState?.sectionName}` : ""
    }`
  );
};
export const getAllContentLogs = (searchState: any) => {
  return axios.get(
    `/content/logs?${searchState.searchName ? `searchTerm=${searchState.searchName}` : ""}${
      searchState?.type ? `&type=${searchState?.type}` : ""
    }&limit=${searchState?.limit ? searchState?.limit : 10}`
  );
};

export const getContentById = (id: any) => {
  return axios.get(`/content/${id}`);
};

export const updateContentById = (id: string, dataToUpdate: []) => {
  return axios.patch(`/content/${id}`, { updateBody: dataToUpdate });
};
export const createHelpContent = (dataToUpdate: []) => {
  return axios.post(`/content/help`, { helpDetails: dataToUpdate });
};
